import { FormProvider as Form } from "react-hook-form";

interface Props {
  children: React.ReactNode;
  methods: any;
  onSubmit: any;
}

export default function FormProvider({ children, onSubmit, methods }: Props) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
